<div class="fingerprint">
    <div class="content">
        <h1>{{ title }}</h1>
        <p>{{ desc }}</p>
    </div>
    <div class="button-wrapper">
        <button (click)="emitbtn.emit(true)" class="general-button send-me-code" id="send-code" tabindex="3">
            <span>לאזור האישי</span>
        </button>
    </div>
</div>
